import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { MenuCreatePricenextrasPage } from "../menu-create-pricenextras/menu-create-pricenextras";
import { Globals } from "../../../../globals";
import { MenuServices } from "../../services";
import { DishServices } from "../../../dish/services";
import { DishCreateNamePage } from "../../../dish/dish-create/dish-create-name/dish-create-name";
import { MenuCreateFinishSectionPage } from '../menu-create-finish-section/menu-create-finish-section';
import { StaticsServices } from '../../../services/statics';
import { ProductsServices } from '../../../products/services';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the MenuCreateDishSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-create-dish-select',
  templateUrl: 'menu-create-dish-select.html',
})
export class MenuCreateDishSelectPage {

  type: any;
  section_index: any;
  section: any;
  update_state: boolean = false;
  menu_uid: string;
  menu_name: string;
  selected_collapse: boolean = false;
  show_prices: boolean;
  new_menu: boolean = false;
  /**
   * Falta que al editar iniciar los platos que ya estan en la seccion que se quiere editar.
   */

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public menuServices: MenuServices,
    public dishServices: DishServices,
    public toastCtrl: ToastController,
    public staticsServices: StaticsServices,
    public productServices: ProductsServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    private analyticsServices: AnalyticsServices) {

    this.type = this.navParams.get('type'); //Menu style
    this.section_index = this.navParams.get('section'); //Section index number
    this.update_state = this.navParams.get('update');//Update state
    this.menu_uid = this.navParams.get('menu_uid');//Menu uid
    this.menu_name = this.navParams.get('menu_name');//Menu uid
    this.show_prices = this.navParams.get('show_prices');
    this.new_menu = this.navParams.get('new_menu');

    if (!this.update_state && this.section_index == 0) { //BASIC BUFFETE APERITIVOS new menu
      //Creamos la base de los objectos de cad seccion
      var _obj: any;
      if (this.type == 'basic') {
        _obj = {
          0: {
            name: this.translate.instant('general-primeros'),
            order: 0,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          },
          1: {
            name: this.translate.instant('general-segundos'),
            order: 1,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          },
          2: {
            name: this.translate.instant('general-postres'),
            order: 2,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          },
        };
      } else if (this.type == 'buffete') {
        _obj = {
          0: {
            name: 'Buffete',
            order: 0,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 2
          },
        };
      } else if (this.type == 'aperitivo') {
        _obj = {
          0: {
            name: this.translate.instant('general-aperitivos'),
            order: 0,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          },
          1: {
            name: this.translate.instant('general-primeros'),
            order: 1,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          },
          2: {
            name: this.translate.instant('general-segundos'),
            order: 2,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          },
          3: {
            name: this.translate.instant('general-postres'),
            order: 3,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          },
        };
      }
      this.menuServices.menu_section_array_complete_tmp = _obj;
    }

    if (!this.update_state && this.type == 'freestyle') { //Freestyle new menu
      var _obj_freestyle: any;
      const freestyleSectionName = this.translate.instant('general-seccion') + ' ' + (parseInt(this.section_index) + 1);
      if (this.section_index == 0) {
        //Creamos array tmp
        _obj_freestyle = {
          0: {
            name: freestyleSectionName,
            order: 0,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          },
        };
        this.menuServices.menu_section_array_complete_tmp = _obj_freestyle;
      } else {
        //Si no es la primera seccion creamos solo la nueva seccion
        this.menuServices.menu_section_array_complete_tmp[this.section_index] = {
          name: freestyleSectionName,
          order: 0,
          font_size: 18,
          font_family: 'Arial',
          font_color: '#000',
          text_align: 'center',
          dish: Array(),
          column: 1
        };
      }
    }

    if (!this.update_state && this.type == 'combo') { //combo new menu
      var _obj_combo: any;
      const comboSectionName = this.translate.instant('general-seccion') + ' ' + (parseInt(this.section_index) + 1);
      if (this.section_index == 0) {
        //Creamos array tmp
        _obj_combo = {
          0: {
            name: comboSectionName,
            order: 0,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1,
            combo_required: false,
            combo_select_multi: false,
            combo_cost_extra: false,
          },
        };
        this.menuServices.menu_section_array_complete_tmp = _obj_combo;
      } else {
        //Si no es la primera seccion creamos solo la nueva seccion
        this.menuServices.menu_section_array_complete_tmp[this.section_index] = {
          name: comboSectionName,
          order: 0,
          font_size: 18,
          font_family: 'Arial',
          font_color: '#000',
          text_align: 'center',
          dish: Array(),
          column: 1,
          combo_required: false,
          combo_select_multi: false,
          combo_cost_extra: false,
        };
      }
    }

    if (this.update_state) {
      if (!this.navParams.get('new')) {//Editem seccio
        var section_index_complete = this.navParams.get('section_complete');
        var _dish = section_index_complete[this.section_index].dish; //Get the dish section's
        for (let key in _dish) {
          var _array = Array();
          _array.push(_dish[key].uid); //UID [0]
          _array.push(_dish[key].order !== undefined ? _dish[key].order : parseInt(key)); //Order [1]
          _array.push(_dish[key].name || ''); //[2]
          _array.push(_dish[key].name_ca || ''); //[3]
          _array.push(_dish[key].name_en || ''); //[4]
          _array.push(_dish[key].name_de || ''); //[5]
          _array.push(_dish[key].name_fr || ''); //[6]
          _array.push(_dish[key].name_it || ''); //[7]
          // Allergens [8] - Validar que sea un array
          if (Array.isArray(_dish[key].allergens)) {
            _array.push(_dish[key].allergens);
          } else {
            _array.push([]);
          }
          // Foodcost_static [9]
          if (_dish[key].foodcost_static !== undefined && _dish[key].foodcost_static !== null) {
            _array.push(parseFloat(_dish[key].foodcost_static) || 0);
          } else {
            _array.push(0);
          }
          // Foodcost_parts [10]
          if (_dish[key].foodcost_parts !== undefined && _dish[key].foodcost_parts !== null) {
            _array.push(parseFloat(_dish[key].foodcost_parts) || 0);
          } else {
            _array.push(0);
          }
          _array.push(_dish[key].type || 'dish'); //[11]
          // Price [12]
          if (_dish[key].price !== undefined && _dish[key].price !== null) {
            _array.push(parseFloat(_dish[key].price) || 0);
          } else {
            _array.push(0);
          }
          // Price_combo_extra [13]
          if (_dish[key].price_combo_extra !== undefined && _dish[key].price_combo_extra !== null) {
            _array.push(parseFloat(_dish[key].price_combo_extra) || 0);
          } else {
            _array.push(0);
          }
          // Price_takeaway [14]
          if (_dish[key].price_takeaway !== undefined && _dish[key].price_takeaway !== null) {
            _array.push(parseFloat(_dish[key].price_takeaway) || 0);
          } else {
            _array.push(0);
          }
          _array.push(_dish[key].description_es || ''); //[15]
          _array.push(_dish[key].description_ca || ''); //[16]
          _array.push(_dish[key].description_en || ''); //[17]
          _array.push(_dish[key].description_de || ''); //[18]
          _array.push(_dish[key].description_fr || ''); //[19]
          _array.push(_dish[key].description_it || ''); //[20]
          // Tags [21] - CRÍTICO: Validar que sea un array, si no lo es, usar array vacío
          if (Array.isArray(_dish[key].tags)) {
            _array.push(_dish[key].tags);
          } else {
            // Si tags existe pero no es array (datos corruptos), ignorarlo y usar array vacío
            _array.push([]);
          }
          // Price_supplement [22]
          if (_dish[key].price_supplement !== undefined && _dish[key].price_supplement !== null) {
            _array.push(parseFloat(_dish[key].price_supplement) || 0);
          } else {
            _array.push(0);
          }
          this.menuServices.menu_dish_array_tmp.push(_array);
        }
        // Hacer copia profunda para evitar que el observable modifique los datos mientras editamos
        this.menuServices.menu_section_array_complete_tmp = JSON.parse(JSON.stringify(section_index_complete));
      } else {
        // Copia profunda para evitar mutar el objeto del subscription de Firestore
        this.menuServices.menu_section_array_complete_tmp = JSON.parse(JSON.stringify(this.menuServices.menu_tmp.sections));
        //miramos si es freestyle o combo
        const updateSectionName = this.translate.instant('general-seccion') + ' ' + (parseInt(this.section_index) + 1);
        if (this.type == 'freestyle') {
          this.menuServices.menu_section_array_complete_tmp[this.section_index] = {
            name: updateSectionName,
            order: 0,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          };
        } else if (this.type == 'combo') {
          this.menuServices.menu_section_array_complete_tmp[this.section_index] = {
            name: updateSectionName,
            order: 0,
            font_size: 18,
            font_family: 'Arial',
            font_color: '#000',
            text_align: 'center',
            dish: Array(),
            column: 1
          };
        }
      }
    }

    if (this.type == 'basic') {
      if (this.section_index == '0') {
        this.section = this.translate.instant('general-primeros');
      } else if (this.section_index == '1') {
        this.section = this.translate.instant('general-segundos');
      } else if (this.section_index == '2') {
        this.section = this.translate.instant('general-postres');
      }
    } else if (this.type == 'buffete') {
      if (this.section_index == '0') {
        this.section = 'Platos';
      }
    } else if (this.type == 'aperitivo') {
      if (this.section_index == '0') {
        this.section = this.translate.instant('general-aperitivos');
      } else if (this.section_index == '1') {
        this.section = this.translate.instant('general-primeros');
      } else if (this.section_index == '2') {
        this.section = this.translate.instant('general-segundos');
      } else if (this.section_index == '3') {
        this.section = this.translate.instant('general-postres');
      }
    }
  }


  ionViewWillEnter() {
    this.menuServices.getPagesDishesProducts(0);
    this.menuServices.page_active = 1;
  }

  openMenuNext() {
    this.updateSection();// Anadimos los platos al array tmp de todas las secciones

    if (this.type == 'basic') {

      if (this.section_index == '0') {
        this.globals.tourLaunchStep(10);

        this.navCtrl.push(MenuCreateDishSelectPage, {
          type: "basic",
          section: '1',
          update: this.update_state,
          menu_uid: this.menu_uid,
          new_menu: this.new_menu
        });

      } else if (this.section_index == '1') {
        this.globals.tourLaunchStep(12);
        this.navCtrl.push(MenuCreateDishSelectPage, {
          type: "basic",
          section: '2',
          update: this.update_state,
          menu_uid: this.menu_uid,
          new_menu: this.new_menu
        });

      } else if (this.section_index == '2') {
        this.globals.tourLaunchStep(14);
        this.globals.GAtrackView('Menu', 'Menu - Section - Create', this.globals.restaurant.email, 'Create/Update', 'Create section', 'Menu', '');
        this.updateFirestore(); //Guardamos secciones en Firestore
        this.goToPriceExtras();
      }

    } else if (this.type == 'buffete') {
      if (this.section_index == '0') {
        this.globals.GAtrackView('Menu', 'Menu - Section - Create', this.globals.restaurant.email, 'Create/Update', 'Create section', 'Menu', '');
        this.updateFirestore(); //Guardamos secciones en Firestore
        this.goToPriceExtras();
      }
    } else if (this.type == 'aperitivo') {
      if (this.section_index == '0') {
        this.navCtrl.push(MenuCreateDishSelectPage, {
          type: "aperitivo",
          section: '1',
          update: this.update_state,
          menu_uid: this.menu_uid,
          new_menu: this.new_menu
        });
      } else if (this.section_index == '1') {
        this.navCtrl.push(MenuCreateDishSelectPage, {
          type: "aperitivo",
          section: '2',
          update: this.update_state,
          menu_uid: this.menu_uid,
          new_menu: this.new_menu
        });
      } else if (this.section_index == '2') {
        this.navCtrl.push(MenuCreateDishSelectPage, {
          type: "aperitivo",
          section: '3',
          update: this.update_state,
          menu_uid: this.menu_uid,
          new_menu: this.new_menu
        });
      } else if (this.section_index == '3') {
        this.globals.GAtrackView('Menu', 'Menu - Section - Create', this.globals.restaurant.email, 'Create/Update', 'Create section', 'Menu', '');
        this.updateFirestore(); //Guardamos secciones en Firestore
        this.goToPriceExtras();
      }

    } else if (this.type === 'freestyle') {
      //abrir pagina intermedia
      this.navCtrl.push(MenuCreateFinishSectionPage, {
        type: "freestyle",
        section: Number(this.section_index) + 1,
        update: this.update_state,
        menu_uid: this.menu_uid,
        show_prices: this.show_prices,
        new_menu: this.new_menu
      });
    } else if (this.type === 'combo') {
      //abrir pagina intermedia
      this.navCtrl.push(MenuCreateFinishSectionPage, {
        type: "combo",
        section: Number(this.section_index) + 1,
        update: this.update_state,
        menu_uid: this.menu_uid,
        show_prices: this.show_prices,
        new_menu: this.new_menu
      });
    }

  }

  updateSection() {
    //Preparamos el objecto para insertarlo en los dish del menu
    var _obj = {};
    for (var i = 0; this.menuServices.menu_dish_array_tmp.length > i; i++) {
      this.menuServices.sumands = this.menuServices.sumands + this.menuServices.menu_dish_array_tmp[i][9];
      this.menuServices.count_tmp++;

      //Comprovamos que el elemento tenga la descripcion
      if (this.menuServices.menu_dish_array_tmp[i][13] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][13] = 0;
      }
      if (this.menuServices.menu_dish_array_tmp[i][14] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][14] = 0;
      }
      if (this.menuServices.menu_dish_array_tmp[i][15] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][15] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][16] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][16] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][17] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][17] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][18] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][18] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][19] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][19] = '';
      }
      if (this.menuServices.menu_dish_array_tmp[i][20] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][20] = '';
      }
      // Validar allergens [8] - CRÍTICO: debe ser un array
      if (!Array.isArray(this.menuServices.menu_dish_array_tmp[i][8])) {
        this.menuServices.menu_dish_array_tmp[i][8] = [];
      }
      // Validar tags [21] - CRÍTICO: debe ser un array
      if (!Array.isArray(this.menuServices.menu_dish_array_tmp[i][21])) {
        this.menuServices.menu_dish_array_tmp[i][21] = [];
      }
      if (this.menuServices.menu_dish_array_tmp[i][22] == undefined) {
        this.menuServices.menu_dish_array_tmp[i][22] = 0;
      }

      _obj[i] = {
        uid: this.menuServices.menu_dish_array_tmp[i][0],
        order: this.menuServices.menu_dish_array_tmp[i][1],
        name: this.menuServices.menu_dish_array_tmp[i][2],
        name_ca: this.menuServices.menu_dish_array_tmp[i][3],
        name_en: this.menuServices.menu_dish_array_tmp[i][4],
        name_de: this.menuServices.menu_dish_array_tmp[i][5],
        name_fr: this.menuServices.menu_dish_array_tmp[i][6],
        name_it: this.menuServices.menu_dish_array_tmp[i][7],
        allergens: this.menuServices.menu_dish_array_tmp[i][8],
        foodcost_static: this.menuServices.menu_dish_array_tmp[i][9],
        foodcost_parts: this.menuServices.menu_dish_array_tmp[i][10],
        type: this.menuServices.menu_dish_array_tmp[i][11],
        price: this.menuServices.menu_dish_array_tmp[i][12],
        price_combo_extra: this.menuServices.menu_dish_array_tmp[i][13],
        price_takeaway: this.menuServices.menu_dish_array_tmp[i][14],
        description_es: this.menuServices.menu_dish_array_tmp[i][15],
        description_ca: this.menuServices.menu_dish_array_tmp[i][16],
        description_en: this.menuServices.menu_dish_array_tmp[i][17],
        description_de: this.menuServices.menu_dish_array_tmp[i][18],
        description_fr: this.menuServices.menu_dish_array_tmp[i][19],
        description_it: this.menuServices.menu_dish_array_tmp[i][20],
        tags: this.menuServices.menu_dish_array_tmp[i][21],
        price_supplement: this.menuServices.menu_dish_array_tmp[i][22]
      };

      this.globals.dataSet('menu_dish', this.menuServices.menu_dish_array_tmp[i][2], '', this.menuServices.menu_section_array_complete_tmp[this.section_index].name, '');

    }

    //

    this.menuServices.menu_section_array_complete_tmp[this.section_index].dish = _obj; // Insertamos dish al menu
    this.menuServices.menu_dish_array_tmp = Array(); //Limpiamos el array
  }

  updateFirestore() {
    // Asegurar que todos los campos de idioma de la sección estén completos
    if (this.menuServices.menu_section_array_complete_tmp[this.section_index]) {
      this.menuServices.menu_section_array_complete_tmp[this.section_index] = 
        this.menuServices.ensureSectionLanguageFields(
          this.menuServices.menu_section_array_complete_tmp[this.section_index], 
          this.globals.restaurant.lang
        );
    }

    this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
      'sections': this.menuServices.menu_section_array_complete_tmp,
      'style': this.type
    }).then(() => {
    });
  }

  update() {
    if (this.navParams.get('new')) {
      this.analyticsServices.trackingExp('crear secció menu', this.globals.tracking_exp['create_section'], '');
    }
    this.updateSection();
    this.updateFirestore();
    this.recalculate();
    this.navCtrl.pop();
  }

  finishMenuSelect() {
    /*
    * Funcion para los estilo libre para terminar el menu y guardar
    * */

    this.updateSection();// Anadimos los platos al array tmp de todas las secciones
    this.updateFirestore(); //Guardamos secciones en Firestore
    this.goToPriceExtras();

  }

  goToPriceExtras() {

    this.navCtrl.push(MenuCreatePricenextrasPage, {
      update: false,
      menu_uid: this.menu_uid,
      price: 0,
      price_takeaway: 0,
      extra_price: 0,
      new_menu: this.new_menu
    });


  }

  ionViewDidLeave() {
    this.menuServices.menu_dish_array_tmp = Array();
  }

  openDishCreate() {
    this.dishServices.quick_create = true;
    this.navCtrl.push(DishCreateNamePage);
  }

  async recalculate() {
    //
    var average_foodcost = 0;

    //recorremos las secciones
    for (var i = 0; Object.keys(this.menuServices.menu_section_array_complete_tmp).length > i; i++) {
      //init vars per section
      var average_section = 0;
      var count_section = 0;
      //recorremos los elementos
      for (var j = 0; Object.keys(this.menuServices.menu_section_array_complete_tmp[i].dish).length > j; j++) {
        if (this.menuServices.menu_section_array_complete_tmp[i].dish[j].type == 'product') {
          //recuperamos producto
          var element = await this.productServices.getProduct(this.menuServices.menu_section_array_complete_tmp[i].dish[j].uid);
          //miramos si es un producto compuesto o basico
          if (element.sub_recipe) {//compuesto
            average_section = parseFloat(element.price_static) / parseFloat(element.foodcost_parts);
            count_section++;
          } else {//basico
            average_section = parseFloat(element.price_static);
            count_section++;
          }
        } else {
          //recuperamos plato
          var element_dish = await this.dishServices.getDish(this.menuServices.menu_section_array_complete_tmp[i].dish[j].uid);
          average_section = parseFloat(element_dish.foodcost_static) / parseFloat(element_dish.foodcost_parts);
          count_section++;
        }
        //this.menuServices.sumands = this.menuServices.sumands + parseFloat(element.foodcost_static);
        //this.menuServices.count_tmp++;
      }
      //sumamos el calculo de la media de cada seccion
      average_foodcost += (average_section / count_section);
    }

    var menu = await this.menuServices.getMenu(this.menu_uid);

    average_foodcost = average_foodcost + parseFloat(menu.extra);
    this.menuServices.menu_cost = average_foodcost;

    //this.menuServices.menu_cost = this.menuServices.sumands / this.menuServices.count_tmp;
    //this.menuServices.menu_cost = this.menuServices.menu_cost + parseFloat(menu.extra);

    this.staticsServices.updateMenuCost(this.menu_uid);
  }

  deleteSection() {
    let confirmed = false;
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-eliminar-seccion'),
      message: this.translate.instant('instant-seguro-quieres-eliminarla'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            confirmed = true;
            if (!this.navParams.get('new')) {
              // Sección existente: eliminar de Firestore
              delete this.menuServices.menu_section_array_complete_tmp[this.section_index];
              var obj_help = {};
              var i = 0;
              for (let item of this.globals.objectToArray(this.menuServices.menu_section_array_complete_tmp)) {
                obj_help[i] = item;
                i++;
              }
              this.menuServices.menu_section_array_complete_tmp = obj_help;
              this.menuServices.menu_tmp.sections = obj_help;
              this.menuServices.sections_array_tmp = this.globals.objectToArray(obj_help);
              this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
                'sections': obj_help,
              });
            }
            this.menuServices.edit = false;
          }
        }
      ]
    });
    alert.onDidDismiss(() => {
      if (confirmed) {
        this.navCtrl.pop();
      }
    });
    alert.present();
  }
  searchProductsDishesNode(value) {
    this.menuServices.searchProductsDishesNode(value);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-dish-select/menu-create-dish-select.ts